<template>
  <div class="invoice-details pb-9" v-if="pageLoaded">
    <v-card class="pa-6">
      <div class="d-flex flex-row align-end">
        <h4 class="c-grey pt-2 ps-2">جزئیات فاکتور {{ invoiceData.code }}</h4>
        <div v-if="invoiceData.type == 'proforma'" class="blue-badge ms-auto">
          پیش‌فاکتور
        </div>
        <div
          v-else-if="invoiceData.type == 'return'"
          class="pink-badge ms-auto"
        >
          مرجوعی
        </div>
      </div>

      <hr class="mt-5" />
      <v-tabs v-model="tab">
        <v-tab> جزئیات فاکتور </v-tab>
        <v-tab
          @click="
            currentPage = 1;
            perPage = 10;
          "
          v-if="invoiceData.returnedInvoices"
        >
          فاکتور‌های مرجوعی
        </v-tab>
        <v-tab
          v-if="invoiceData.returnedIncomes"
          @click="
            currentPage = 1;
            perPage = 10;
          "
        >
          پرداخت‌های مرجوعی
        </v-tab>
      </v-tabs>
      <hr style="margin-top: 0 !important" />
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <div class="text-center pb-12" v-if="isLoading">
            <cube></cube>
            <span style="font-size: 16px">در حال بارگذاری ...</span>
          </div>
          <div v-else class="mt-5">
            <v-row v-if="invoiceData.type == 'return'" class="pe-2">
              <v-col></v-col>
              <v-col class="text-end py-0">
                <v-btn class="blue-mainBtn mb-6" @click="submitAgain()">
                  ثبت مجدد فاکتور
                </v-btn></v-col
              >
            </v-row>

            <div style="font-size: 1rem">
              <v-row class="ps-2 pe-2">
                <v-col>
                  <b>نام مشتری: </b>
                  <span>{{ invoiceData.shopCustomerName }} </span>
                  <!-- <span>
                    {{
                      tiers.filter(
                        (x) => x.value == invoiceData.shopCustomerTier
                      )[0]
                        ? "(مشتری " +
                          tiers.filter(
                            (x) => x.value == invoiceData.shopCustomerTier
                          )[0].text +
                          ")"
                        : ""
                    }}</span 
                  >-->
                </v-col>
                <v-col class="text-left">
                  <b>شماره سفارش: </b>
                  <span>{{ invoiceData.code }}</span>
                </v-col>
              </v-row>

              <v-row class="ps-2 pe-2">
                <v-col>
                  <b>شماره همراه مشتری: </b>
                  <span>{{
                    invoiceData.shopCustomerMobile
                      ? invoiceData.shopCustomerMobile
                      : "-"
                  }}</span>
                </v-col>
                <v-col class="text-left">
                  <b>تاریخ خرید: </b>
                  <span>{{ invoiceData.date }}</span>
                  -
                  <b>زمان خرید: </b>
                  <span>{{ invoiceData.time }}</span>
                </v-col>
              </v-row>
            </div>
            <hr />
            <span v-show="false">{{ reactivity }}</span>
            <div class="custom-table bordered mt-8 pb-1">
              <b-table
                responsive
                show-empty
                stacked="sm"
                :items="invoiceData.details"
                :fields="fields"
                empty-text="هنوز کالایی به فاکتور اضافه نشده است"
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    <v-icon class="red--text text--lightem-1 me-2"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="red--text font-weight-bold text--lightem-1"
                      >هنوز کالایی به فاکتور اضافه نشده است</span
                    >
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:head(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      min-width: 300px;
                    "
                  >
                  <span v-if="isPriceChanged(data)" class="me-1">*</span>
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(price)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ Number(data.value).toLocaleString() }}
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <span v-show="false">{{ reactivity }}</span>
                    {{
                      (
                        Number(data.item.amount) * data.item.price
                      ).toLocaleString()
                    }}
                  </div>
                </template>
              </b-table>
              <div>
                <hr class="my-8" />
                <div class="mb-9" v-if="invoiceData.useRoyaltyCredit">
                  <span class="font-weight-bold c-purple">
                    <v-icon class="me-1" style="color: #775aa6 !important"
                      >mdi-alert-octagram-outline</v-icon
                    >
                    در این خرید از اعتبار استفاده شده است.</span
                  >
                </div>
                <v-row class="c-grey" style="font-size: 17px">
                  <v-col lg="6" md="12" cols="12">
                    <v-row>
                      <v-col>
                        <span> قیمت کل </span>
                      </v-col>
                      <v-col>
                        {{
                          Number(computedTotalPrice).toLocaleString() + " ریال "
                        }}
                      </v-col>
                    </v-row>
                    <v-row v-if="!invoiceData.useRoyaltyCredit">
                      <v-col>
                        <span> تخفیف </span>
                      </v-col>
                      <v-col>
                        {{
                          Number(invoiceData.discount).toLocaleString() +
                          " ریال "
                        }}
                      </v-col>
                    </v-row>
                    <!--<v-row v-else>
                      <v-col>
                        <span> مبلغ اعتبار (ریال) </span>
                      </v-col>
                      <v-col>
                        {{ Number(invoiceData.royaltyDiscount).toLocaleString() }}
                      </v-col>
                    </v-row>-->
                    <v-row>
                      <v-col>
                        <span> مالیات </span>
                      </v-col>
                      <v-col v-if="invoiceData.details">
                        {{
                          parseInt(
                            ((invoiceData.details
                              .map((x) => Number(x.price) * Number(x.amount))
                              .reduce((a, b) => a + b, 0) -
                              invoiceData.discount) *
                              invoiceData.vat) /
                              100
                          ).toLocaleString() + " ریال "
                        }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <hr class="mt-8 mb-4" />
                <v-row class="c-grey my-4">
                  <v-col lg="6" md="12" cols="12">
                    <v-row style="font-size: 19px">
                      <v-col>
                        <span> مبلغ قابل پرداخت </span>
                      </v-col>

                      <v-col>
                        {{
                          parseInt(invoiceData.totalCost).toLocaleString() +
                          " ریال "
                        }}
                      </v-col>
                    </v-row>
                    <v-row
                      style="font-size: 19px"
                      v-if="invoiceData.income.isPartial"
                    >
                      <v-col>
                        <span> مبلغ پرداخت جزئی </span>
                      </v-col>
                      <v-col>
                        {{
                          parseInt(
                            invoiceData.income.partialAmount
                          ).toLocaleString() + " ریال "
                        }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div
              class="mt-8 pa-8 payment-box"
              v-if="
                invoiceData.type == 'proforma' || invoiceData.type == 'return'
              "
            >
              <h4 class="box-title">توضیحات</h4>
              <p>
                {{
                  invoiceData.description
                    ? invoiceData.description
                    : "توضیحی برای این فاکتور ثبت نشده‌ است."
                }}
              </p>
            </div>
            <div class="mt-8 pa-8 payment-box" v-else>
              <h4 class="box-title">اطلاعات پرداخت</h4>
              <v-row
                style="font-size: 15px"
                v-if="invoiceData.income.isPartial"
              >
                <v-col>
                  <h5 class="primary--text font-weight-bold me-2">
                    <v-icon class="me-1">mdi-cash</v-icon>
                    پرداخت ثبت شده جزیی است
                    <span class="grey--text text--darken-1">
                      ( مقدار پرداخت:
                      {{
                        Number(
                          invoiceData.income.partialAmount
                        ).toLocaleString() + " ریال "
                      }}
                      )
                    </span>
                  </h5>
                </v-col>
              </v-row>
              <v-row class="mt-1" style="font-size: 15px">
                <v-col>
                  <b>نوع پرداخت: </b>
                  <span>{{
                    invoiceData.type == "respite"
                      ? "امانی - پرداخت اعتباری"
                      : invoiceData.type == "definite"
                      ? "قطعی - پرداخت در لحظه"
                      : "-"
                  }}</span>
                  <div v-if="invoiceData.type == 'definite'" class="mt-5">
                    <b>نحوه پرداخت: </b>
                    <span>{{
                      paymentTypes.filter(
                        (x) => x.value == invoiceData.income.paymentType
                      )[0]
                        ? paymentTypes.filter(
                            (x) => x.value == invoiceData.income.paymentType
                          )[0].text
                        : "-"
                    }}</span>

                    <v-row
                      class="mt-4"
                      v-if="invoiceData.income.paymentType == 'cheque'"
                    >
                      <v-col
                        ><b>شماره چک:</b>
                        {{ invoiceData.income.chequeNo }}</v-col
                      >
                      <v-col class="text-center"
                        ><b>نام بانک:</b>
                        {{ invoiceData.income.chequeBank }}</v-col
                      >
                      <v-col class="text-center"
                        ><b>شماره صیاد: </b>
                        {{ invoiceData.income.chequeSayyad }}</v-col
                      >
                      <v-col class="text-left"
                        ><b>تاریخ چک: </b>
                        {{ invoiceData.income.chequeDate }}</v-col
                      >
                      <v-col class="text-left"
                        ><b>وضعیت چک: </b>
                        {{
                          chequeStatuses.filter(
                            (x) => x.value == invoiceData.income.chequeStatus
                          )[0]
                            ? chequeStatuses.filter(
                                (x) =>
                                  x.value == invoiceData.income.chequeStatus
                              )[0].text
                            : "-"
                        }}</v-col
                      >
                    </v-row>

                    <v-row
                      class="mt-4"
                      v-if="invoiceData.income.paymentType == 'cardTransfer'"
                    >
                      <v-col
                        ><b>شماره کارت فرستنده:</b>
                        {{ invoiceData.income.buyerCardNumber }}</v-col
                      >
                      <v-col class="text-center"
                        ><b>شماره کارت گیرنده:</b>
                        {{ invoiceData.income.recipientCardNumber }}</v-col
                      >
                    </v-row>
                  </div>
                </v-col>
              </v-row>
              <v-row style="font-size: 15px">
                <v-col>
                  <b>توضیحات: </b>
                  <p class="text-justify">
                    {{
                      invoiceData.description
                        ? invoiceData.description
                        : "توضیحی برای این فاکتور ثبت نشده‌ است."
                    }}
                  </p>
                </v-col>
              </v-row>
            </div>
            <div class="py-5">
              <v-btn
                @click="printInvoice()"
                class="darkRed-mainBtn white--text"
                elevation="0"
                width="140"
                v-if="invoiceData.type != 'return'"
              >
                <v-icon class="me-1" color="white">mdi-printer</v-icon>
                پرینت
                {{ invoiceData.type == "proforma" ? "پیش فاکتور" : "فاکتور" }}
              </v-btn>
              <v-btn
                width="140"
                class="lime-mainBtn ms-1 float-end"
                :to="'/shop/editinvoice/' + $route.params.id"
                v-if="invoiceData.type != 'return'"
                ><v-icon class="me-1">mdi-pencil</v-icon>ویرایش
              </v-btn>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item v-if="invoiceData.returnedInvoices">
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="invoiceData.returnedInvoices"
              :fields="returnInvoiceFields"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(totalCost)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="purple-mainBtn"
                    width="120"
                    >نمایش عملیات</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="120"
                    >بستن عملیات</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn mb-2"
                  style="text-align: center; vertical-align: middle"
                >
                  <v-btn
                    @click="goToReturnedInvoice(row.item.shopInvoiceId)"
                    class="green-mainBtn"
                    width="135"
                    height="40"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده جزئیات</v-btn
                  >
                  <v-btn
                    class="purple-mainBtn ms-1"
                    width="135"
                    height="40"
                    @click="
                      $router.push(
                        '/print/invoice/invoice/' + row.item.shopInvoiceId
                      )
                    "
                    ><v-icon class="me-1">mdi-printer</v-icon>چاپ رسید</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </v-col>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="
                      Math.ceil(invoiceData.returnedInvoices.length / perPage)
                    "
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item v-if="invoiceData.returnedIncomes">
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="invoiceData.returnedIncomes"
              :fields="returnIncomeFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(amount)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() + " ریال " }}
                </div>
              </template>
              <template v-slot:cell(operation)="data">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    class="purple-mainBtn"
                    width="120"
                    @click="doPrint2(data.item)"
                  >
                    <v-icon class="me-1">mdi-printer</v-icon>
                    چاپ رسید
                  </v-btn>
                </div>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </v-col>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="
                      Math.ceil(invoiceData.returnedInvoices.length / perPage)
                    "
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- receipt -->
    <v-card
      class="pa-2"
      style="direction: rtl"
      v-show="false"
      id="paymentReceipt"
    >
      <div class="container mb-0" style="border: 1px solid black">
        <div
          style="
            text-align: center;
            width: 100%;
            border-bottom: 1px solid black;
          "
        >
          <span style="font-size: 18px">فروشگاه پولاد پیچ کار</span>
        </div>

        <div style="padding: 0 15px">
          <div style="direction: rtl">
            <div
              style="
                border: 1px solid black;
                border-radius: 10px;
                padding: 0 10px;
                margin-bottom: 10px;
                margin-top: 10px;
              "
            >
              <div style="text-align: center">
                <span style="font-size: 19px"> رسید پرداخت (چاپ مجدد) </span>
              </div>
              <br />
              <div>
                <table
                  style="
                    border: 0px solid black !important;
                    break-inside: avoid;
                  "
                >
                  <tr>
                    <td style="border: 0px solid black !important">
                      نام مشتری:
                      {{ returnedIncomesArray.shopCustomerName }}
                    </td>
                    <td
                      style="
                        border: 0px solid black !important;
                        text-align: left;
                      "
                    >
                      تاریخ:
                      {{
                        returnedIncomesArray.date
                          ? returnedIncomesArray.date.split(" ")[0]
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid black !important">
                      کد مشتری:
                      {{ returnedIncomesArray.shopCustomerCode }}
                    </td>
                    <td
                      style="
                        border: 0px solid black !important;
                        text-align: left;
                      "
                    >
                      ساعت:
                      {{
                        returnedIncomesArray.time
                          ? returnedIncomesArray.time.split(" ")[0]
                          : ""
                      }}
                    </td>
                  </tr>
                </table>

                <br />
              </div>
            </div>
            <div style="padding: 0 10px">
              <table
                style="border: 0px solid black !important; break-inside: avoid"
              >
                <tr>
                  <td
                    v-if="returnedIncomesArray.paymentType == 'cheque'"
                    style="border: 0px solid black !important"
                  >
                    <span
                      >شیوه پرداخت:
                      {{
                        paymentTypes.filter(
                          (x) => x.value == returnedIncomesArray.paymentType
                        )[0]
                          ? paymentTypes.filter(
                              (x) => x.value == returnedIncomesArray.paymentType
                            )[0].text
                          : "-"
                      }}
                    </span>
                  </td>
                  <td
                    v-if="returnedIncomesArray.paymentType == 'cheque'"
                    style="border: 0px solid black !important"
                  >
                    <span>{{
                      "شماره چک: " + returnedIncomesArray.chequeNo
                    }}</span>
                  </td>
                </tr>
                <tr v-if="returnedIncomesArray.paymentType == 'cheque'">
                  <td style="border: 0px solid black !important">
                    <span>{{
                      "شماره صیاد: " + returnedIncomesArray.chequeSayyad
                    }}</span>
                  </td>
                  <td style="border: 0px solid black !important">
                    <span>{{
                      "نام بانک: " + returnedIncomesArray.chequeBank
                    }}</span>
                  </td>
                </tr>
                <tr v-if="returnedIncomesArray.paymentType == 'cheque'">
                  <td style="border: 0px solid black !important">
                    <span>{{
                      "تاریخ چک: " + returnedIncomesArray.chequeDate
                    }}</span>
                  </td>
                </tr>
                <tr v-if="returnedIncomesArray.paymentType == 'cardTransfer'">
                  <td style="border: 0px solid black !important">
                    <span>{{
                      "شماره کارت فرستنده: " +
                      returnedIncomesArray.buyerCardNumber
                    }}</span>
                  </td>
                  <td
                    style="border: 0px solid black !important; text-align: left"
                  >
                    <span>{{
                      "شماره کارت گیرنده: " +
                      returnedIncomesArray.recipientCardNumber
                    }}</span>
                  </td>
                </tr>
              </table>

              <table style="border: 0px solid black !important">
                <tr>
                  <td style="border: 0px solid black !important">
                    مبلغ پرداخت:
                    {{ Number(returnedIncomesArray.amount).toLocaleString() }}
                    ریال
                  </td>
                  <td
                    v-if="returnedIncomesArray.paymentType != 'cheque'"
                    style="border: 0px solid black !important; text-align: left"
                  >
                    <span
                      >نحوه پرداخت:
                      {{
                        paymentTypes.filter(
                          (x) => x.value == returnedIncomesArray.paymentType
                        )[0]
                          ? paymentTypes.filter(
                              (x) => x.value == returnedIncomesArray.paymentType
                            )[0].text
                          : "-"
                      }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
            <div
              style="
                    border: 1px solid black;
                    border-radius: 10px;
                    min-height: 80px;
                    padding: 10px;
                    margin-top: 15px
                    break-inside: avoid
                  "
            >
              <span>توضیحات: {{ returnedIncomesArray.description }}</span>
            </div>
            <br />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import VueBarcode from "vue-barcode";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    barcode: VueBarcode,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      selectedIndex: "",
      selectedItem: {},
      type: "reprint",
      tab: null,
      isLoading: false,
      moment: moment,
      reactivity: false,
      busy: false,
      text: "",
      perPage: 10,
      currentPage: 1,
      perPageOptions: [4, 10, 20],
      invoiceData: {
        income: {
          chequeNo: "",
          chequeBank: "",
          chequeDate: "",
        },
      },
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (ریال)" },
      ],
      fieldspaymentReceipt: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد" },
        { key: "status", label: "وضعیت" },
        { key: "totalCost", label: "قیمت کل" },
      ],
      returnInvoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      returnIncomeFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد پرداخت" },
        { key: "amount", label: "مبلغ پرداخت شده" },
        { key: "status", label: "وضعیت" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "زمان" },
        { key: "operation", label: "عملیات" },
      ],
      //tiers: [
      //  { value: "coper", text: "برنزی" },
      //  { value: "silver", text: "نقره‌ای" },
      //  { value: "gold", text: "طلایی" },
      //  { value: "diamond", text: "الماس" },
      //],
      gettingBalance: false,
      pageLoaded: false,
      returnedItems: [],
      chequeStatuses: [
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
        { value: "submitted", text: "ثبت شده" },
      ],
      returnedIncomesArray: {},
    };
  },
  methods: {
    isPriceChanged(data) {
      if (data.item.manualPrice) {
        return true;
      } else {
        return false;
      }
    },
    submitAgain() {
      //localStorage.setItem("invoiceData", JSON.stringify(this.invoiceData));
      this.$router.push("/shop/newInvoice?invoiceId=" + this.$route.params.id);
    },
    doPrint2(item) {
      this.returnedIncomesArray = {};
      this.returnedIncomesArray = item;
      setTimeout(() => {
        this.printPaymentReceipt();
      }, 200);
    },
    getData() {
      this.isLoading = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/sales/getData/" + this.$route.params.id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.invoiceData = res.data;
            this.isLoading = false;
            this.pageLoaded = true;

            try {
              this.returnedItems = this.invoiceData.returnedInvoices
                ? this.invoiceData.returnedInvoices[0].details
                : [];
            } catch (error) {
              this.returnedItems = [];
              console.log(error);
            }

            this.getBalance(this.invoiceData.shopCustomerId);
          } else {
            this.toast(res.data, "error");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response, "error");
          this.isLoading = false;
        });
    },
    getBalance(customerId) {
      this.gettingBalance = true;
      this.invoiceData.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            // this.royaltyCreditAmount = res.data.royaltyCreditAmount;
            // let royaltyCreditType = res.data.royaltyCreditType;
            // this.royaltyCreditType =
            //   royaltyCreditType == "normal"
            //     ? "معمولی"
            //     : royaltyCreditType == "vip"
            //     ? "ویژه"
            //     : "فاقد اعتبار";
            this.invoiceData.customerBalance = res.data.balanceData;
            if (this.invoiceData.customerBalance > 0) {
              this.invoiceData.customerBalance =
                this.invoiceData.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.invoiceData.customerBalance < 0) {
              this.invoiceData.customerBalance =
                Math.abs(this.invoiceData.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.invoiceData.customerBalance = "تسویه";
            }
            setTimeout(() => {
              this.gettingBalance = false;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    goToReturnedInvoice(id) {
      localStorage.setItem("fromParentInvoice", true);
      let link = "/shop/invoice/" + id;
      window.open(link, "_blank");
    },
    printInvoice() {
      localStorage.setItem(
        "oldCustomerBalance",
        this.invoiceData.customerBalance
      );
      if (this.invoiceData.type == "proforma") {
        this.$router.push(
          "/print/" + this.type + "/preinvoice/" + this.$route.params.id
        );
      } else {
        this.$router.push(
          "/print/" + this.type + "/invoice/" + this.$route.params.id
        );
      }
    },
    printPaymentReceipt() {
      //printing receipt
      var myWindow = window.open(
        "#",
        "paymentReceipt",
        "height=auto,width=800"
      );
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/customReceipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(
        document.getElementById("paymentReceipt").innerHTML
      );
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
  },
  computed: {
    computedTotalPrice() {
      if (this.invoiceData) {
        if (this.invoiceData.details) {
          let total = 0;
          this.invoiceData.details.forEach((x) => {
            total = total + Number(x.amount) * Number(x.price);
          });
          this.reactivity = !this.reactivity;
          return total;
        }
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.invoice-details {
  .bordered {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 25px;
    min-height: 400px;
  }
}
.payment-box {
  border: 1px solid #ccc;
  border-radius: 10px;
  position: relative;
  .box-title {
    position: absolute;
    top: -13px;
    background-color: #fff;
    padding: 0 15px;
  }
}
</style>
